import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../../store";

const selectMachineryGroupsState = (state: RootState) => state.machineryGroups;

export const selectMachineryGroups = createSelector(
    [selectMachineryGroupsState],
    (s) => s.groups,
);

export const selectMachineryGroupFilter = createSelector(
    [selectMachineryGroupsState],
    (s) => s.groupFilter,
);

export const selectMachineryGroupsIsSaving = createSelector(
    [selectMachineryGroupsState],
    (s) => s.isSaving,
);

export const selectMachineryGroupsIsLoading = createSelector(
    [selectMachineryGroupsState],
    (s) => s.isLoading,
);

/** Есть ли вообще группы — по нему решается, показывать ли фильтр и колонку. */
export const selectHasMachineryGroups = createSelector(
    [selectMachineryGroups],
    (groups) => groups.length > 0,
);
